import React from 'react';
import { bool, object } from 'prop-types';
import { connect } from 'react-redux';

import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import SeoIndexAlphabetNav from '../../components/SeoDiscovery/SeoIndexAlphabetNav';
import SeoIndexPagination from '../../components/SeoDiscovery/SeoIndexPagination';
import { propTypes } from '../../util/types';
import css from '../../components/SeoDiscovery/SeoDiscovery.module.css';
import {
  CITY_INDEX_PAGE_SIZE,
  citiesIndexPath,
  citiesLetterPath,
} from '../../util/seoDiscoveryIndexLetters';

const cityLabel = city => [city.city, city.state].filter(Boolean).join(', ');
const letterTitle = letter => (letter === '#' ? '0–9' : letter);

export const SeoDiscoveryCitiesLetterPageComponent = props => {
  const { data, fetchInProgress, fetchError } = props;
  const cities = data?.cities || [];
  const letter = data?.letter || 'A';
  const letterCounts = data?.letterCounts || {};
  const total = data?.total || 0;
  const page = data?.page || 1;
  const letterLabel = letterTitle(letter);

  return (
    <Page
      title={`Cities starting with ${letterLabel} | PromoTix`}
      description={`Browse cities starting with ${letterLabel}. Find upcoming events, tickets, and venue guides by city.`}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: `PromoTix Cities — ${letterLabel}`,
      }}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.root}>
          <p className={css.indexBreadcrumb}>
            <a href={citiesIndexPath()}>Cities</a>
            {' / '}
            {letterLabel}
          </p>
          <h1 className={css.h1}>Cities — {letterLabel}</h1>
          <p>Discover upcoming events and venue guides in cities starting with {letterLabel}.</p>
          {fetchError ? <p>Unable to load cities.</p> : null}
          {fetchInProgress && !cities.length ? <p>Loading…</p> : null}
          <SeoIndexAlphabetNav
            activeLetter={letter}
            letterCounts={letterCounts}
            getLetterHref={citiesLetterPath}
          />
          <section className={css.letterSection}>
            <h2 className={css.letterHeading}>{letterLabel}</h2>
            <ul className={css.indexList}>
              {cities.map(c => (
                <li key={c.slug}>
                  <a href={c.path}>{cityLabel(c)}</a>
                  <span className={css.eventMeta}>
                    {' '}
                    — {c.eventCount || 0} event{(c.eventCount || 0) === 1 ? '' : 's'},{' '}
                    {c.venueCount || 0} venue{(c.venueCount || 0) === 1 ? '' : 's'}
                  </span>
                </li>
              ))}
            </ul>
          </section>
          <SeoIndexPagination
            currentPage={page}
            pageSize={CITY_INDEX_PAGE_SIZE}
            total={total}
            getPageHref={nextPage => citiesLetterPath(letter, nextPage)}
          />
          <p>
            <a href={citiesIndexPath()}>Back to all city letters</a>
          </p>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

SeoDiscoveryCitiesLetterPageComponent.propTypes = {
  data: object,
  fetchInProgress: bool,
  fetchError: propTypes.error,
};

const mapStateToProps = state => state.SeoDiscoveryCitiesLetterPage || {};

export default connect(mapStateToProps)(SeoDiscoveryCitiesLetterPageComponent);
